export default __webpack_public_path__ + "static/media/onzen_diagram.38ad4ead.png";